import React from 'react'
import { EMERGING_ARTIST_IMAGE } from '../../helpers/constants'

const Component = (): React.ReactElement<React.ComponentProps<any>, any> => {
  return (
    <div data-section='emerging-artists'>
      <div data-type='text-section'>
        <p data-type='subtitle'>
          Saatchi Art is Home to the Best Emerging Artists Around the Globe
        </p>
        <div data-type='underline' />
        <p data-type='description'>
          We have thousands of artist relationships in more than 100 countries to directly leverage
          for client design projects around the world, plus:
        </p>
        <ul>
          <li>
            Extensive experience working directly with artists and fabricators to create special
            commissions and custom installations
          </li>
          <li>
            Vast array of art products including prints, paintings, tapestries, woven wall hangings,
            ceramic installations, stone signage, metalwork suspended chandeliers, bespoke quilting,
            plaster and resin bas reliefs, and more
          </li>
          <li>Our fingers are on the pulse of what's new and next in art and design</li>
        </ul>
      </div>
      <picture data-type='image'>
        <img
          width='700'
          height='824'
          itemProp='image'
          className='lazyload'
          data-src={EMERGING_ARTIST_IMAGE}
          alt='emerging artist'
          role='presentation'
          data-type='image'
        />
      </picture>
    </div>
  )
}

export default Component